import { useRoutes } from "react-router-dom";
import Grower from "./Grower";
import InternalEmails from "./InternalEmails/index";
import LandingPage from "./Landing";
import NoMatch404 from "./PageNotFound";
import Supplier from "./Supplier";
import User from "./User";
import ClientPage from "./Client";
import TenantItems from "./TenantItems";
import SignalRulesAdmin from "./SignalRulesAdmin";

export type AdminPageRouteObject = {
    title: string;
    path: string;
    element?: JSX.Element;
    children?: AdminPageRouteObject[];
}

export const adminMenu: AdminPageRouteObject[] = [
    {
        title: "Users",
        path: "users",
        children: [
            {
                title: "User",
                path: "user",
                element: <User/>
            },
        ],
    },
    {
        title: "Sourcing",
        path: "sourcing",
        children: [
            {
                title: "Client",
                path: "end_client",
                element: <ClientPage />
            },
            {
                title: "Supplier",
                path: "supplier",
                element: <Supplier />
            },
            {
                title: "Grower",
                path: "grower",
                element: <Grower />
            },
            {
                title: "Internal Emails",
                path: "internal-emails",
                element: <InternalEmails />
            },
        ],
    },
    {
        title: "Items",
        path: "tenant-items",
        children: [
            {
                title: "Items",
                path: "items",
                element: <TenantItems />
            },
        ],
    },
    {
        title: "Signals",
        path: "signals",
        children: [
            {
                title: "Rules",
                path: "rules",
                element: <SignalRulesAdmin />
            },
        ],
    },
    // hide this for now
    // {
    //     title: "Fruit",
    //     path: "fruit",
    //     children: [
    //         {
    //             title: "Variety",
    //             path: "variety",
    //             element: <div>Variety</div>
    //         },
    //         {
    //             title: "Size",
    //             path: "size",
    //             element: <div>Size</div>
    //         },
    //     ]
    // },
    // {
    //     title: "Delivery",
    //     path: "delivery",
    //     children: [
    //         {
    //             title: "End Clients",
    //             path: "end-clients",
    //         },
    //         {
    //             title: "Sup-refs",
    //             path: "sup-refs",
    //         },
    //         {
    //             title: "Products",
    //             path: "products",
    //         },
    //     ]
    // },
];

export function AdminPageRouter() {
    const router = useRoutes([
        {
            title: "Landing",
            path: "",
            element: <LandingPage />
        },
        ...adminMenu,
        {
            title: "Page Not Found",
            path: "*",
            element: <NoMatch404 />
        }
    ]);
    return router;
}
